import script from "./MediaFull.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaFull.vue?vue&type=script&setup=true&lang=js"

import "./MediaFull.vue?vue&type=style&index=0&id=6c1f303c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c1f303c"]])

export default __exports__